module.exports = __webpack_public_path__ + "static/media/background.3e1cad81.png";